// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.discussion {
   
  max-height: 250px;
    .chat-messages {
        width: 100%;
        max-width: 1200px;
        margin: 0 auto;
        overflow-y: scroll;
        height: 54vh;
      }
      
      .message-row {
        display: flex;
        flex-direction: row;
        padding-bottom: 10px;
        /* border-bottom: 1px solid rgba(161, 161, 161, 1); */
      }
      
     .message-row.user-message,
     .bot-message{
        border-bottom: none;
        padding-bottom: 0;
        padding: 0px !important;
      }
    
    
    
      .message-content {
        width: 65%;
        /* margin-right: 30px; */
      }

      .audio-player {
        margin-left: auto;
        display: flex;
        align-items: center;
        /* Additional styles if needed */
      }
      
      
      .message-info {
        display: flex;
        flex-direction: row;
        margin-top: 1%;
        /* border: 1px solid #4E4E4E;
        border-radius: 10px; */
        padding-top: 1%;
        align-items: flex-start;
      }
      
      .avatar {
        width: 30px;
        /* padding-left: 10px; */
        margin: 10px;
        padding: 0px;
      }
      
      .sender-name {
        margin-left: 2%;
        color: rgba(155, 156, 158, 1);
        font-size: 12px;
        margin-top: 5px;
      }
    
      .formatted-message {
        color: white;
      }
      
      .message-text {
        padding: 5px 0;
        font-size: 10px;
        text-align: left;
        font-family: Graphik;
        color: white;
      }

      /* ThreeDotsLoader.css */
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
}

.loader-f {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 187px;
  padding-top: 50px;
}

.dot {
  width: 10px;
  height: 10px;
  margin: 0 5px;
  border-radius: 50%;
  display: inline-block;
  animation: bounce 1.4s infinite ease-in-out;
}

.red {
  background-color: #8070d4;
  /* Red color */
  animation-delay: -0.32s;
}

.green {
  background-color: #8070d4;
  /* Green color */
  animation-delay: -0.16s;
}

.blue {
  background-color: #8070d4;
  /* Blue color */
}

.loading-text {
  background-color: #3498db;
  /* Red color */
  animation-delay: -0.48s;
}

@keyframes bounce {

  0%,
  80%,
  100% {
    transform: translateY(0);
  }

  40% {
    transform: translateY(-10px);
  }
}
}

.partner-dropdown {
  margin-top: 4px;
  /* margin-bottom: 1px; */
  display: flex;
  justify-content: center;
}

.partner-background {
  background: #42466B;
  border: 1px solid #202342;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/CustomerCare/ChatBotDiscussion.css"],"names":[],"mappings":"AAAA;;EAEE,iBAAiB;IACf;QACI,WAAW;QACX,iBAAiB;QACjB,cAAc;QACd,kBAAkB;QAClB,YAAY;MACd;;MAEA;QACE,aAAa;QACb,mBAAmB;QACnB,oBAAoB;QACpB,qDAAqD;MACvD;;KAED;;QAEG,mBAAmB;QACnB,iBAAiB;QACjB,uBAAuB;MACzB;;;;MAIA;QACE,UAAU;QACV,wBAAwB;MAC1B;;MAEA;QACE,iBAAiB;QACjB,aAAa;QACb,mBAAmB;QACnB,gCAAgC;MAClC;;;MAGA;QACE,aAAa;QACb,mBAAmB;QACnB,cAAc;QACd;8BACsB;QACtB,eAAe;QACf,uBAAuB;MACzB;;MAEA;QACE,WAAW;QACX,wBAAwB;QACxB,YAAY;QACZ,YAAY;MACd;;MAEA;QACE,eAAe;QACf,6BAA6B;QAC7B,eAAe;QACf,eAAe;MACjB;;MAEA;QACE,YAAY;MACd;;MAEA;QACE,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,YAAY;MACd;;MAEA,wBAAwB;AAC9B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,uBAAuB;AACzB;;AAEA;;EAEE;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF;AACA;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd","sourcesContent":[".discussion {\n   \n  max-height: 250px;\n    .chat-messages {\n        width: 100%;\n        max-width: 1200px;\n        margin: 0 auto;\n        overflow-y: scroll;\n        height: 54vh;\n      }\n      \n      .message-row {\n        display: flex;\n        flex-direction: row;\n        padding-bottom: 10px;\n        /* border-bottom: 1px solid rgba(161, 161, 161, 1); */\n      }\n      \n     .message-row.user-message,\n     .bot-message{\n        border-bottom: none;\n        padding-bottom: 0;\n        padding: 0px !important;\n      }\n    \n    \n    \n      .message-content {\n        width: 65%;\n        /* margin-right: 30px; */\n      }\n\n      .audio-player {\n        margin-left: auto;\n        display: flex;\n        align-items: center;\n        /* Additional styles if needed */\n      }\n      \n      \n      .message-info {\n        display: flex;\n        flex-direction: row;\n        margin-top: 1%;\n        /* border: 1px solid #4E4E4E;\n        border-radius: 10px; */\n        padding-top: 1%;\n        align-items: flex-start;\n      }\n      \n      .avatar {\n        width: 30px;\n        /* padding-left: 10px; */\n        margin: 10px;\n        padding: 0px;\n      }\n      \n      .sender-name {\n        margin-left: 2%;\n        color: rgba(155, 156, 158, 1);\n        font-size: 12px;\n        margin-top: 5px;\n      }\n    \n      .formatted-message {\n        color: white;\n      }\n      \n      .message-text {\n        padding: 5px 0;\n        font-size: 10px;\n        text-align: left;\n        font-family: Graphik;\n        color: white;\n      }\n\n      /* ThreeDotsLoader.css */\n.loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n}\n\n.loader-f {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n  width: 187px;\n  padding-top: 50px;\n}\n\n.dot {\n  width: 10px;\n  height: 10px;\n  margin: 0 5px;\n  border-radius: 50%;\n  display: inline-block;\n  animation: bounce 1.4s infinite ease-in-out;\n}\n\n.red {\n  background-color: #8070d4;\n  /* Red color */\n  animation-delay: -0.32s;\n}\n\n.green {\n  background-color: #8070d4;\n  /* Green color */\n  animation-delay: -0.16s;\n}\n\n.blue {\n  background-color: #8070d4;\n  /* Blue color */\n}\n\n.loading-text {\n  background-color: #3498db;\n  /* Red color */\n  animation-delay: -0.48s;\n}\n\n@keyframes bounce {\n\n  0%,\n  80%,\n  100% {\n    transform: translateY(0);\n  }\n\n  40% {\n    transform: translateY(-10px);\n  }\n}\n}\n\n.partner-dropdown {\n  margin-top: 4px;\n  /* margin-bottom: 1px; */\n  display: flex;\n  justify-content: center;\n}\n\n.partner-background {\n  background: #42466B;\n  border: 1px solid #202342;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
